<template>
  <v-container>
    <v-card
      :loading="false"
    >
      <v-overlay
        :absolute="true"
        :value="isComponentLoading"
      >
        <v-progress-circular indeterminate size="24"></v-progress-circular>
      </v-overlay>
      <v-row class="pa-3">
        <v-col cols="12" md="4">
          <v-menu
            v-model="menuFrom"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="fromDateFormatted"
                @input="changeDate('from', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_from')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.from" no-title
                           :first-day-of-week="1"
                           @input="menuFrom = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-menu
            v-model="menuTo"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :value="toDateFormatted"
                @input="changeDate('to', $event)"
                :label="lang($store, 'sap/listings.global.filter.hints.date_to')"
                prepend-icon="mdi-calendar"
                readonly
                clearable
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="searchParams.to" no-title
                           :first-day-of-week="1"
                           @input="menuTo = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" md="4">
          <v-select
            v-model="searchParams.region"
            :hint="lang($store, 'sap/listings.global.filter.hints.region')"
            :items="regionsItems"
            persistent-hint
            single-line
            :loading="false"
          ></v-select>
        </v-col>
      </v-row>
      <v-row class="pa-2">
        <v-col>
          <div>
            <span
              v-if="stats"
            >
              {{ $t('stats.payments') }}: <b>{{ stats.payments ? stats.payments : 0 }}</b>
            </span>
          </div>
          <div>
            <span
              v-if="stats"
            >
              {{ $t('stats.salary') }}: <b>{{ stats.salary ? stats.salary : 0 }}</b>
            </span>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
import moment from 'moment';
import regionsFilter from '@/mixins/filters/regionsFilter';
import StatsFinanceProxy from '@/proxies/Stats/StatsFinanceProxy';
import { DATE_ISO } from '@/constants/dates';

export default {
  name: 'StatsFinanceGeneral',
  mixins: [
    regionsFilter,
  ],
  data() {
    return {
      isComponentLoading: false,
      menuFrom: false,
      menuTo: false,
      searchParams: {
        from: null,
        to: null,
        region: null,
      },
      stats: {},
    };
  },
  computed: {
    fromDateFormatted() {
      return this.formatDate(this.searchParams.from);
    },
    toDateFormatted() {
      return this.formatDate(this.searchParams.to);
    },
  },
  mounted() {
    this.searchParams.from = moment()
      // .subtract(7, 'days')
      .startOf('day')
      .format(DATE_ISO);
    this.searchParams.to = moment()
      .add(1, 'days')
      .startOf('day')
      .format(DATE_ISO);
  },
  watch: {
    searchParams: {
      handler() {
        this.financeQuery();
      },
      deep: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    financeQuery() {
      new StatsFinanceProxy()
        .setParameters(this.searchParams)
        .general()
        .then((response) => {
          this.stats = response.data.data.stats;
        });
    },
  },
};
</script>

<style scoped>

</style>
